import { PortableText } from "@portabletext/react";
import { Container } from "./styles";

type Props = {
  blocks: any[];
};

const Content: React.FC<Props> = (props) => {
  const { blocks } = props;
  if (!blocks?.length) return null;

  return (
    <Container>
      <PortableText value={blocks} />
    </Container>
  );
};

export default Content;
